export const translations = {
  CLOSEST_DELIVERY_DATE: {
    en: 'Closest delivery date:',
    sv: 'Nästa utdelningsdag:',
  },
  NEXT_DELIVERY_DATE: {
    en: 'Next delivery date:',
    sv: 'Kommande utdelningsdag:',
  },
  ZIP_CODE: {
    en: 'Zip code:',
    sv: 'Postnummer:',
  },
  VALIDATION_ERROR_MESSAGE: {
    en: 'Zip code not valid',
    sv: 'Postnumret är inte giltigt',
  },
  SERVER_ERROR_MESSAGE: {
    en: 'Could not find zip code',
    sv: 'Kan inte hitta postnumret',
  },
  PLACEHOLDER_TEXT: {
    en: 'Search for a zip code',
    sv: 'Sök på ett postnummer',
  },
};
